<template>
  <section class="dimension-card">
    <h3 class="dimension-title">
      作品类型分布
    </h3>
    <div
      v-if="items.length"
      class="work-type-grid"
    >
      <div
        v-for="item in items"
        :key="item.name"
        class="work-type-item"
        :class="{ 'is-product-row': item.isProduct }"
      >
        <span
          class="work-type-name"
          :title="item.name"
        >{{ item.name }}</span>
        <div class="progress-track">
          <div
            class="progress-value"
            :class="{ 'is-product': item.isProduct }"
            :style="{ width: `${item.progress}%` }"
          />
        </div>
        <span class="work-type-count">{{ item.count }} 件</span>
        <span class="work-type-percent">{{ item.percentage }}%</span>
      </div>
    </div>
    <div
      v-else
      class="empty-text"
    >
      暂无数据
    </div>
  </section>
</template>

<script setup>
import { computed, onMounted, shallowRef } from 'vue'
import { getWorkTypeDistribution } from '@/api/normalChannelStatistics'

const sourceItems = shallowRef([])

const items = computed(() => {
  const maxCount = Math.max(...sourceItems.value.map(item => item.count), 0)
  return sourceItems.value.map((item) => ({
    ...item,
    progress: maxCount > 0 ? (item.count / maxCount) * 100 : 0
  }))
})

async function loadWorkTypeDistribution() {
  try {
    const response = await getWorkTypeDistribution()
    const data = response && response.code === 200 && Array.isArray(response.data)
      ? response.data
      : []
    sourceItems.value = data.map(item => ({
      name: item.name || '-',
      count: Number(item.count) || 0,
      percentage: Number(String(item.percentage || 0).replace('%', '')) || 0,
      isProduct: Boolean(item.isProduct)
    }))
  } catch (error) {
    console.error('查询作品类型分布失败:', error)
    sourceItems.value = []
  }
}

onMounted(loadWorkTypeDistribution)
</script>

<style lang="scss" scoped>
.dimension-card {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 24px 24px;
  border: 1px solid #ebeef5;
  border-radius: 2px;
  background: #fff;
}

.dimension-title {
  margin: 0 0 22px;
  color: #333;
  font-size: 18px;
  font-weight: bold;
}

.work-type-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 52px;
  row-gap: 16px;
}

.empty-text {
  padding: 54px 0;
  color: #999;
  font-size: 14px;
  text-align: center;
}

.work-type-item {
  display: grid;
  grid-template-columns: minmax(118px, 1.35fr) minmax(110px, 1.5fr) 58px 42px;
  align-items: center;
  gap: 10px;
  min-width: 0;
  color: #333;
  font-size: 13px;

  &.is-product-row {
    grid-column: 1 / -1;
    order: 1;
    width: calc(50% - 26px);
  }
}

.work-type-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.progress-track {
  height: 14px;
  overflow: hidden;
  background: #f0f2f5;
}

.progress-value {
  height: 100%;
  background: #ffbd2e;

  &.is-product {
    background: #ad552c;
  }
}

.work-type-count,
.work-type-percent {
  white-space: nowrap;
}

@media (max-width: 1024px) {
  .work-type-grid {
    column-gap: 24px;
  }

  .work-type-item {
    grid-template-columns: minmax(100px, 1.2fr) minmax(90px, 1.3fr) 54px 38px;
    gap: 7px;
    font-size: 12px;

    &.is-product-row {
      width: calc(50% - 12px);
    }
  }
}

@media (max-width: 768px) {
  .dimension-card {
    padding: 16px;
  }

  .dimension-title {
    margin-bottom: 18px;
    font-size: 16px;
  }

  .work-type-grid {
    grid-template-columns: 1fr;
  }

  .work-type-item.is-product-row {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .dimension-card {
    padding: 12px;
  }

  .work-type-item {
    grid-template-columns: minmax(88px, 1.1fr) minmax(72px, 1fr) 50px 34px;
    gap: 5px;
    font-size: 11px;
  }
}
</style>
